module.exports = __webpack_public_path__ + "static/media/2018_0808_03484200-01.552f807b.jpg";